// extracted by mini-css-extract-plugin
module.exports = {"createdUserMessage":"createUserForm_createdUserMessage__3ufDo","email":"createUserForm_email__1sjtW","password":"createUserForm_password__S3mhL","not":"createUserForm_not__2tHWb"};